// ReactJS
import { useEffect, useMemo, useState } from "react";

// Material UI
import { Button, Divider, Grid, Paper, Typography } from "@mui/material";

// Context
import { useTablon } from "../../contexts/TablonContext";
import ViewTitulo from "../../components/Tablon/Perfil/ViewTitulo";

import { getTiempoRestante } from "../../utils/articuloTypeUtils"
import Lote from "../../components/Tablon/Mercado/Lote";


const style = {
    p: 2,
    position: "relative",
};

function Mercado(params) {

    const { usuario, getMercado, mercado } = useTablon();

    const payload = {
        id: usuario ? usuario.id : null,
        registro: "vigente"
    };

    // Cargar misiones al entrar
    useEffect(() => {
        if (!usuario) return;

        getMercado(payload);

    }, [usuario]);

    // console.log(mercado);


    // Tiempo
    // let tiempoRestante = articulo.articulo.fecha_fin === null ? "" : getTiempoRestante(articulo.articulo.fecha_fin ? articulo.articulo.fecha_fin : "2030/12/10 00:00:00")
    // eslint-disable-next-line
    const [_, setTick] = useState(0);
    useEffect(() => {
        const i = setInterval(() => setTick(t => t + 1), 1000);
        // if (tiempoRestante === "Vencida") {
        //     getUsuario(usuario.matricula, true, true)
        // }
        return () => clearInterval(i);
    }, []);



    return (<>
        <Grid container spacing={2}>
            <ViewTitulo texto="Mercado" update={() => getMercado(payload)} />

            <Grid size={{ xs: 12 }}>
                <Typography variant="h5" fontWeight={"bold"} textAlign={"center"}>
                    Compra
                </Typography>
            </Grid>
            <Grid size={{ xs: 12 }}>
                <Typography variant="h5" fontWeight={"bold"} textAlign={"center"}>
                    Venta
                </Typography>
            </Grid>
            {mercado != null &&
                mercado.map((element, i) => {
                    return (
                        <Grid size={{ xs: 12 }} key={i}>
                            <Lote data={element} i={i}></Lote>
                        </Grid>
                    )
                })
            }
        </Grid>

    </>)
}

export default Mercado;